import { apiClient } from './api-client';

export interface GenerateOfferLetterData {
  offeredPrice: number;
  sellerName?: string;
  sellerAddress?: string;
  sellerPhone?: string;
  depositAmount?: number;
  paymentTerms?: string;
  loanCondition?: boolean;
  loanAmount?: number;
  loanDuration?: number;
  loanMaxRate?: number;
  noEncumbranceCondition?: boolean;
  otherConditions?: string;
  legalRestrictions?: string;
  ppeWorks?: string;
  fiscalValue?: string;
  otherPriceElements?: string;
  acceptanceDeadline: string;
  retractationIndemnity?: number;
}

export interface GenerateOfferLetterResult {
  fileId: string;
  url: string;
  filename: string;
}

export const documentService = {
  async generateOfferLetter(
    propertyId: string,
    data: GenerateOfferLetterData,
  ): Promise<GenerateOfferLetterResult> {
    return await apiClient.post<GenerateOfferLetterResult>(
      `/properties/${propertyId}/generate-offer`,
      data,
    );
  },

  async generateBankDossier(
    propertyId: string,
    tauxCapitalisation: number,
  ): Promise<GenerateOfferLetterResult> {
    return await apiClient.post<GenerateOfferLetterResult>(
      `/properties/${propertyId}/generate-bank-dossier`,
      { tauxCapitalisation },
    );
  },
};
